<template>

  <!-- Participate Element -->
  <page-block
    bg-image-contain
    :bg-file="value.file"
    :bg-color="value.bgColor"
    class="participate-element"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    :width-class="value.widthClass"
    :overlay-class="value.paddingClass || 'q-pa-none'">

    <q-btn
      rounded
      unelevated
      @click="$refs.dialog.show()"
      class="block-btn bg-brand-gradient text-white">
      Принять участие
    </q-btn>

    <participate-dialog
      ref="dialog"
      :body="value.body"
      :title="value.title"
      :bg-file="value.file"
      :buttons="value.buttons"
      :bg-color="value.bgColor"/>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import ParticipateDialog from 'components/dialog/participate-dialog';

  export default {
    name: 'participate-element',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      ParticipateDialog,
    },
  };

</script>

<style lang="scss">

  .participate-element {
    color: inherit;
  }

</style>
